import React, { useState, useCallback } from 'react';
import { Card, Button, Table, Pagination, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import {
  getTableHeaderClass,
  getModernDataTableClass,
  getModernCardHeaderClass,
  getModernCardBodyClass,
  getModernCardFooterClass,
  getModernTableClass,
  getModernDataTableMetaClass,
} from 'utils/tableTheme';

const DryersTable = ({ data, onRemoveButton, permission, theme }) => {
  const history = useHistory();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [showModal, setShowModal] = useState(false);
  const [selectedSerial, setSelectedSerial] = useState(null);

  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(Number(event.target.value));
  }, []);

  const handleShowModal = (_id, e) => {
    e.stopPropagation();
    setSelectedSerial(_id);
    setShowModal(true);
  };

  const handleConfirmRemove = () => {
    onRemoveButton(selectedSerial);
    setShowModal(false);
  };

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const paginatedData = data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  const getPaginationRange = () => {
    const start = Math.max(page - 2, 0);
    const end = Math.min(page + 2, totalPages - 1);
    let range = [];

    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  };

  const handleRowClick = (id) => {
    // Removido o redirecionamento para equipamentos, pois agora são secadores
    // history.push(`/equipments/${id}`);
  };

  return (
    <div>
      <p className={getModernDataTableMetaClass()}>
        {data.length} registros encontrados. Página {page + 1} de {totalPages}
      </p>
      <Card className={getModernDataTableClass(theme)}>
        <Card.Header className={getModernCardHeaderClass(theme)}>
          Secadores
        </Card.Header>
        <Card.Body className={getModernCardBodyClass(theme)}>
          <Table
            style={{ fontSize: "0.9rem" }}
            hover
            responsive
            size="sm"
            className={getModernTableClass(theme)}
          >
            <thead>
              <tr className={getTableHeaderClass(theme)}>
                <th className='text-center'>NOME</th>
                <th className='text-center'>LOCALIZAÇÃO</th>
                <th className='text-center'>Nº EQUIPAMENTOS</th>
                <th className='text-center'>AÇÃO</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item) => (
                <tr
                  key={item._id}
                  className="clickable-row"
                  style={{ cursor: 'pointer' }}
                >
                  <td className='text-center pt-2'>{item.nome || '--'}</td>
                  <td className='text-center pt-2'>{item.localizacao || '--'}</td>
                  <td className='text-center pt-2'>
                    <span className="badge bg-primary">
                      {item.equipamentos ? item.equipamentos.length : 0}
                    </span>
                  </td>
                  <td className='text-center'>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={(e) => handleShowModal(item._id, e)}
                      disabled={!permission}
                    >
                      Remover
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer className={getModernCardFooterClass(theme)}>
          <div>
            <label>
              Linhas por página:{' '}
              <select className="modern-data-table__rows-select"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}>
                {[20, 40, 60].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <Pagination className="custom-pagination" variant="dark">
            <Pagination.Prev
              onClick={() => handleChangePage(page - 1)}
              disabled={page === 0}
              aria-label="Página anterior"

            />
            {getPaginationRange().map((index) => (
              <Pagination.Item
                key={index}
                active={index === page}
                onClick={() => handleChangePage(index)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handleChangePage(page + 1)}
              disabled={page >= totalPages - 1}
              aria-label="Próxima página"

            />
          </Pagination>
        </Card.Footer>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        contentClassName={theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Confirmar Remoção</Modal.Title>
        </Modal.Header>
        <Modal.Body className={theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          <p>Você tem certeza que deseja remover o secador {selectedSerial}?</p>
          <p className="text-warning">
            Esta ação irá remover permanentemente o secador e todos os seus dados associados.
          </p>
        </Modal.Body>
        <Modal.Footer className={theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmRemove}>
            Confirmar Remoção
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DryersTable;
